/* eslint-disable max-len */
/* eslint-disable no-console */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	mediaKitData :	{
		folderData     : [],
		sharedData     : [],
		employeeData   : [],
		trashData      : [],
		edmData        : [],
		sharedEdmData  : [],
		whiteLabelData : [],
		myTemplateData : []
	},
	uploadFile   : [],
	downloadInfo : [],
	downloadFile : [],
	zipFile      : [],
	loggingOut   : false
};

export const mediakitslice = createSlice({
	name     : 'mediakit',
	initialState,
	reducers : {
		setMediaKitData : (state, action) =>
		{
			state.mediaKitData = { ...state.mediaKitData, ...action.payload };
		},
		resetMediaKitData : (state) =>
		{
			state.mediaKitData = {
				folderData     : [],
				sharedData     : [],
				employeeData   : [],
				trashData      : [],
				edmData        : [],
				sharedEdmData  : [],
				whiteLabelData : [],
				myTemplateData : []

			};
			state.uploadFile = [];
			state.uploadInfo = [];
			state.loggingOut = false;
		},
		setUploadFile	: (state, action) =>
		{
			state.uploadFile = action.payload;
		},
		setDownloadInfo : (state, action) =>
		{
			state.downloadInfo = action.payload;
		},
		setDownloadFile : (state, action) =>
		{
			state.downloadFile = action.payload;
		},
		setZipFile : (state, action) =>
		{
			state.zipFile = action.payload;
		},
		setLoggingOutForMedia : (state, action) =>
		{
			state.loggingOut = action.payload;
		}
	}
});

export const { setMediaKitData, resetMediaKitData, setUploadFile, setDownloadInfo, setDownloadFile, setZipFile, setLoggingOutForMedia } = mediakitslice.actions;
export default mediakitslice.reducer;